import axios from 'axios'
import qs from 'querystring'
import router from '@/router'

import af from './af'
import ap from './ap'
import kk from './kk'
import st from './st'
import pk from './pk'

axios.defaults.baseURL = process.env.VUE_APP_APIURL
axios.defaults.headers.Pragma = 'no-cache'

// insert auth token if it exists
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken')
    if (token && config.url !== '/token') {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// redirect to login page if 401
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    //console.log(error.response.config.url) - todo, check endswith polyfill
  if (error.response.status === 401 || error.response.status === 403) {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    router.push({ name: 'login' })
  } else {
      return Promise.reject(error);
  }
})

const config = { headers: {'Content-Type': 'application/x-www-form-urlencoded' }}

const api = {

  requestAccessToken (data) {
    return axios.post('/token', qs.stringify({ ...data, grant_type: 'password' }), config)
    .then(response => response.data)
    .catch(() => null)
  },
  requestRefreshToken (refreshToken) {
    return axios.post('/token', qs.stringify({ refresh_token: refreshToken, grant_type: 'refresh_token' }), config)
    .then(response => response.data)
    .catch(() => null)
  },
  resetPassword (email) {
    return axios.post('/api/password/reset', { email })
    .then(response => response.data)
    .catch(error => error.response.data)
  },
  changePassword (data) {
    return axios.post('/api/password/update', data)
    .then(response => response.data)
    .catch(error => error.response.data)
  },
  me () {
    return axios.get('/api/me').then(response => response.data)
  },

  // login

  async getUniversities () {
    return axios.get('/api/login/universities').then(response => response.data)
  },
  async getPharmacies () {
    return axios.get('/api/login/pharmacies').then(response => response.data)
  },
  async getChains () {
    return axios.get('/api/login/chains').then(response => response.data)
  },

  af,
  ap,
  kk,
  st,
  pk,
}

export default api